// src/hooks/useClicFond.ts — SCE Issues
// Fermer une fenêtre en cliquant sur son fond… sans la fermer par erreur
// (06/10, retour de Guillaume) : sélectionner du texte en cliquant-glissant
// dans la fenêtre, et relâcher la souris sur le fond, déclenche un « clic »
// sur le fond — la fenêtre se fermait, la saisie était perdue. Le fond ne
// ferme désormais que si le clic y a aussi COMMENCÉ.

import { useRef, type MouseEvent } from 'react'

export interface GestesFond {
  onMouseDown: (e: MouseEvent<HTMLElement>) => void
  onClick: (e: MouseEvent<HTMLElement>) => void
}

/** À poser sur le fond : `<div className="voile" {...useClicFond(fermer)} />`. */
export function useClicFond(fermer: () => void): GestesFond {
  const appuiSurFond = useRef(false)
  return {
    onMouseDown: (e) => {
      appuiSurFond.current = e.target === e.currentTarget
    },
    onClick: (e) => {
      const surFond = e.target === e.currentTarget && appuiSurFond.current
      appuiSurFond.current = false
      if (surFond) fermer()
    },
  }
}
